

(function() {
  
  
  if(window){
    
  	window.handleConfirm = (metadata, confirmed) => {
      console.log('🚪 Window Confirmed Called');
      if (confirmed) {
        window.location.replace(metadata);
      } else {
        // Perform cancel action
      }
  	};
    
  }
  
  const addEndpoint = 'https://junipurrjewelry.com/cart/add.js';
  
  //used for communication between ios and the application
  
  Shopify.promiseResults = [];
  Shopify.promisesToAdd = [];
  
  Shopify.createAddPromise = function(item){
      return new Promise((resolve, reject) => {
          window.jQuery.post(
              addEndpoint,
              {items: {item}, dataType: 'json'}
          ).done((res)=>{
              console.warn("🙌 Item Added", item, res);
              resolve(res);
          }).catch((error)=>{
              console.warn("⛔ Unable to add item to cart", item, error, error.responsetext.description);
              reject(error);
          });
      });
  }
  
  Shopify.createNotificationPromise = function(item){
    let requestFragment = 'https://09e6cd764d433da7df8204887c46443d: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@junipurr-jewelry.myshopify.com/admin/api/2021-07/variants/'+item.id+'.json';
    console.log(requestFragment);
    window.jQuery.ajax({
      url: requestFragment,
      crossDomain: true,
      dataType: 'json',
      format: "json",
      error: function(jqXHR, textStatus, errorThrown){
        console.log("ERROR :", errorThrown);
      },
      success: function(data, textStatus, jqXHR ){
      	console.log(data);
      }
    });
  }
  
  Shopify.runAddPromise = async function(item){
    
    let toReturn = false;
    console.log("Creating a new Add promise ::", item);
    let promise = await Shopify.createAddPromise(item).then((values) => {
      console.log("🛫 Result ::", values);
      toReturn = true;
      Shopify.promiseResults.push(true);
    }).catch((error) => {
      console.error("📛 Error ::", error);
      Shopify.promiseResults.push(false);
    });
    
    return toReturn;

  }
  
  Shopify.addItemToWaitList = function(product){
    
      let config = {
        url        : theme.settings.apiBase + "/notify",
        method     : "POST",
        dataType   : "json",
        contentType: "application/json",
        cache      : false,
        data       : JSON.stringify({
          email: "mike@chronicinktattoo.com",
          ...product,
        })
      };

      $.ajax(config)
      .done((data) => {
        console.log("added", data);
      }).fail((error) => {
        if (error.responseJSON && error.responseJSON.message && error.status === 409) {
          console.log("ERROR", error);
        } else {
          this.error("Something went wrong. Please try again later");
          console.log("ERROR", error);
        }
      });
  }
  
  if (!window.Junipurr) {
    window.Junipurr = {

      saveBase64Image: function (uri, fileName) {
        function downloadDataUri(uri, fileName) {
          const link = document.createElement('a');
          link.download = fileName;
          link.href = uri;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
        }

        // { type: 'saveBase64Image', image: 'data:image/png;base64,etc', fileName: 'Junipurr Config YYYY-MM-DD_hh-mm.png' }
        const serializedMessage = JSON.stringify({
          type: 'saveBase64Image',
          image: uri,
          fileName,
        });

        // Handle React Native
        const isRNWebView = typeof window?.ReactNativeWebView?.postMessage === 'function';
        if (!isRNWebView) {
        window.ReactNativeWebView?.postMessage(serializedMessage);
        return
        }

        // Handle iOS
        const isIOS = !!(window.webkit?.messageHandlers?.junipurrMessageHandler);
        if (isIOS) {
        const serializedMessageForIos = JSON.stringify({
        type: 'saveBase64Image',
              image: uri.replace('data:image/png;base64,', ''),
                fileName,
      });

        window.webkit?.messageHandlers?.junipurrMessageHandler?.postMessage(serializedMessageForIos);
        return
      }

        // Web
        downloadDataUri(uri, fileName);
      },
          
      shareBase64Image: function (uri, fileName) {
        function downloadDataUri(uri, fileName) {
          const link = document.createElement('a');
          link.download = fileName;
          link.href = uri;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
        }

        // { type: 'saveBase64Image', image: 'data:image/png;base64,etc', fileName: 'Junipurr Config YYYY-MM-DD_hh-mm.png' }
        const serializedMessage = JSON.stringify({
          type: 'shareBase64Image',
          image: uri,
          fileName,
        });

        // Handle React Native
        const isRNWebView = typeof window?.ReactNativeWebView?.postMessage === 'function';
        if (!isRNWebView) {
        window.ReactNativeWebView?.postMessage(serializedMessage);
        return
        }

        // Handle iOS
        const isIOS = !!(window.webkit?.messageHandlers?.junipurrMessageHandler);
        if (isIOS) {
        const serializedMessageForIos = JSON.stringify({
        type: 'shareBase64Image',
              image: uri.replace('data:image/png;base64,', ''),
                fileName,
      });

        window.webkit?.messageHandlers?.junipurrMessageHandler?.postMessage(serializedMessageForIos);
        return
      }

        // Web
        downloadDataUri(uri, fileName);
      },

          /**
             * Mock add items to cart. Shopify should perform the Ajax request with the items.
             * @param items
             * @returns {Promise<boolean>}
             */
        addItemsToCart: async (cartItems) => {

          	//show the loading screen
          	$(".junipurr-ui-loading-screen").css("display", "flex");	
          
            let qty = cartItems.length;
            if(qty === 0 || !window.jQuery){
                console.warn("Requirements Not Met");
                return Promise.resolve(false);
            } else {
			  console.log("🚀 Starting to add items");
              let results = [];
              for(i =0; i<qty; i++){
              	let added = await Shopify.runAddPromise(cartItems[i]);
                results.push(added);
              }
              if(results.includes(true)){
                return Promise.resolve(true);
              } else {
               	return Promise.resolve(false); 
              }

            }
          
          	//removing the loading screen
          	$(".junipurr-ui-loading-screen").css("display", "none");

        },

          /**
             * Shopify host to figure out whether the user is logged in and
             * resolve a promise with a boolean value for the logged in status.
             * The curation tool needs to know whether it should allow the user
             * to attempt to add the items to the cart.
             * It is expected that this operation would fail if the user is not logged in.
             * @returns {Promise<boolean>}
             */
          shouldAllowAddToCart: () => {

            let isLoggedIn = false;
            let redirectURL = null;
            if(ShopifyAnalytics.meta.page.customerId){
              isLoggedIn = true;
            } else {
              redirectURL = "https://junipurrjewelry.com/account/login";
            }

            return Promise.resolve({
              allow: isLoggedIn,
              redirect: redirectURL
            });
          }
      };

      console.log('️%c🌙  Junipurr API', 'font-weight: bold', Object.keys(window.Junipurr));
      console.log(window.Junipurr);
    }

  })();